'use strict';

var RulesFilterByTechnicalIdsFactory = function RulesFilterByTechnicalIdsFactory(DataFilter, $state, strategyConstants) {
  function RulesFilerByTransitionedIds() {
    this.sourceType = ['rule-listing', 'alert-rule-listing'];
    this.filterType = ['rule-listing', 'alert-rule-listing'];
  }
  function gridPanelMatchTransitionPanel(transitionData, sourceType) {
    return transitionData.panel === strategyConstants.PANEL_TYPE.ALERTS && sourceType === 'alert-rule-listing' || transitionData.panel === strategyConstants.PANEL_TYPE.OPTIMIZATION && sourceType === 'rule-listing';
  }
  RulesFilerByTransitionedIds.prototype = Object.create(DataFilter.prototype);
  RulesFilerByTransitionedIds.prototype.filter = function (data) {
    return DataFilter.prototype.filter(data, $state.params.transitionData.rulesIds, 'technicalId');
  };
  RulesFilerByTransitionedIds.prototype.canFilter = function (sourceType, filterType) {
    var transitionData = $state.params.transitionData;
    if (transitionData && transitionData.rulesIds && gridPanelMatchTransitionPanel(transitionData, sourceType)) {
      return this.sourceType.indexOf(sourceType) !== -1 && this.filterType.indexOf(filterType) !== -1;
    }
    return false;
  };
  return RulesFilerByTransitionedIds;
};
RulesFilterByTechnicalIdsFactory.$inject = ['DataFilterFactory', '$state', 'StrategyConstants'];
module.exports = RulesFilterByTechnicalIdsFactory;